import React from "react";
import styles from "./ThumbnailsDesigner.module.scss";

const ThumbnailsDesigner = ({
  thumb: { url, designer, rate, number },
}: any) => {
  return (
    <div className={styles.thumbnailsDesigner}>
      <img
        src={url}
        alt={"alt text for now"}
        className={styles.designerImage}
      />
      <h3>{designer}</h3>
      <h5 className={styles.designerText}>
        {number} patterns
        <br />
        {rate}/5
      </h5>
    </div>
  );
};

export default ThumbnailsDesigner;
